import { useContext, useState, useEffect } from "react";
import { domain, tiers } from "../consts";
import { AlertContext } from "../context/AlertContext";

const InvitationFinish = ({ formData, setFormData }) => {
  const { handleAlert } = useContext(AlertContext);
  const [isLoadingSlug, setIsLoadingSlug] = useState(false);
  const [isValid, setIsValid] = useState(null);
  const [formErrors, setFormErrors] = useState({
    slug: false,
  });

  const handleSlugChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({ ...prev, slug: value }));

    if (!value) {
      setFormErrors((prev) => ({ ...prev, slug: false }));
      setIsValid(null);
      return;
    }

    setTimeout(async () => {
      setIsLoadingSlug(true);
      const urlPattern = /^[a-z0-9&]+(?:-[a-z0-9&]+)*$/;
      const patternIsValid = urlPattern.test(value);
      setIsValid(patternIsValid);

      if (!patternIsValid) {
        handleAlert(
          "Poveznica može sadržavati samo mala slova, brojeve i znak &. Može sadržavati crticu (-) između riječi, ali ne smije završavati sa crticom.",
          "warning",
        );
        setFormErrors((prev) => ({ ...prev, slug: true }));
        setIsLoadingSlug(false);
        return;
      }

      try {
        const response = await fetch(`${domain}/rsvp/check-slug/${value}`, {
          credentials: "include",
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          handleAlert(
            "Ovaj URL je već zauzet. Molimo odaberite drugi.",
            "warning",
          );
          setIsValid(false);
          setFormErrors((prev) => ({ ...prev, slug: true }));
        } else {
          setIsValid(true);
          setFormErrors((prev) => ({ ...prev, slug: false }));
        }
      } catch (error) {
        handleAlert("Došlo je do greške pri provjeri URL-a.", "error");
        setIsValid(false);
        setFormErrors((prev) => ({ ...prev, slug: true }));
      }

      setIsLoadingSlug(false);
    }, 500);
  };
  return (
    <div className="p-4 bg-gray-50 border border-dashed border-gray-200 rounded-xl    ">
      <div className="space-y-4">
        <div>
          <label
            htmlFor="slug"
            className="block text-sm font-medium mb-2  "
          >
            URL pozivnice
          </label>
          <div className="relative">
            <span className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none text-gray-500">
              pozivnica.hr/
            </span>
            <input
              type="text"
              id="slug"
              className={`py-3 ps-[120px] pe-4 block w-full rounded-lg text-sm disabled:opacity-50 disabled:pointer-events-none     ${
                formErrors.slug
                  ? "border-red-500 focus:border-red-500 focus:ring-red-500    :border-red-500"
                  : "border-gray-200 focus:border-teal-500 focus:ring-teal-500    :ring-neutral-600"
              }`}
              placeholder="klara-i-ivan"
              value={formData.slug}
              onChange={handleSlugChange}
              required
            />
          </div>
        </div>
        <div>
          <label
            htmlFor="slug"
            className="block text-sm font-medium mb-2  "
          >
            Odaberi paket
          </label>

          <div className="relative">
            <select
              id="tier"
              className="py-3 block w-full border-gray-200 rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-neutral-600"
              value={formData.tier || 0}
              disabled={formData.id && formData.paymentVerified}
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  tier: Number(e.target.value),
                }));
              }}
            >
              {tiers.map((tier) => (
                <option key={tier.value} value={tier.value}>
                  {tier.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div>
          <label
            htmlFor="shareTitle"
            className="block text-sm font-medium mb-2  "
          >
            Naslov pri djeljenju pozivnice
          </label>
          <div className="relative">
            <input
              type="text"
              id="shareTitle"
              className={`py-3 block w-full rounded-lg text-sm disabled:opacity-50 disabled:pointer-events-none    `}
              placeholder="Klara i Ivan"
              value={formData.shareTitle}
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  shareTitle: e.target.value,
                }));
              }}
              required
            />
          </div>
        </div>

        <div>
          <label
            htmlFor="shareDescription"
            className="block text-sm font-medium mb-2  "
          >
            Opis pri djeljenju pozivnice
          </label>
          <div className="relative">
            <input
              type="text"
              id="shareDescription"
              className={`py-3 block w-full rounded-lg text-sm disabled:opacity-50 disabled:pointer-events-none    `}
              placeholder="Uljepšajte ovaj dan"
              value={formData.shareDescription}
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  shareDescription: e.target.value,
                }));
              }}
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvitationFinish;
